<app-dialog-header [title]="'Detalhes de ' + data.seller_name"></app-dialog-header>

<mat-dialog-content>
  <div class="table-container">
    <p-table [value]="details">
      <ng-template pTemplate="header">
        <tr>
          <th>FORMA PAGAMENTO</th>
          <th>QUANTIDADE</th>
          <th>TOTAL EM R$</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-detail>
        <tr>
          <td>{{ detail.payment_method | paymentMethod }}</td>
          <td>{{ detail.tickets_count }}</td>
          <td>{{ detail.revenue | currency: "BRL" }}</td>
        </tr>
      </ng-template>
      <ng-template pTemplate="footer">
        <tr>
          <td>Total</td>
          <td>
            <b>{{ totalTickets }}</b>
          </td>
          <td>
            <b>{{ totalRevenue | currency: "BRL" }}</b>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</mat-dialog-content>
